// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"4d75d543","28":"004ad7d9","49":"46d7cf9e","185":"cd258dd6","244":"66f0dce1","291":"744c2b19","487":"00651776","562":"75d8c145","605":"9e79fb6e","729":"7451ea39","931":"073f65f7"}[chunkId] + ".chunk.css";
};